var map = {
	"./boston-celtics.svg": 230,
	"./chicago-bulls.svg": 231,
	"./golden-state-warriors.svg": 232,
	"./los-angeles-lakers.svg": 233,
	"./memphis-grizzlies.svg": 234,
	"./minnesota-timberwolves.svg": 235,
	"./orlando-magic.svg": 236,
	"./san-antonio-spurs.svg": 237,
	"./toronto-raptors.svg": 238
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 240;



//////////////////
// WEBPACK FOOTER
// ./src/data/svg ^\.\/.*\.svg$
// module id = 240
// module chunks = 0